import TenantComponents from '@components';
export const TableListingActions = (props) => {
  return <TenantComponents.ListingsRowActions {...props} />;
};
